import { render, staticRenderFns } from "./exhibition-activity-home.vue?vue&type=template&id=b83583a6&scoped=true&"
import script from "./exhibition-activity-home.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-home.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-activity-home.vue?vue&type=style&index=0&id=b83583a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83583a6",
  null
  
)

export default component.exports